import React, { type ReactNode } from 'react';

import AnalyticsContext from './AnalyticsContext';
import type { Analytics } from './adapter/';

interface AnalyticsProviderProps {
  analytics: Analytics;
  children: ReactNode;
}

const AnalyticsProvider = ({ analytics, children }: AnalyticsProviderProps) => (
  <AnalyticsContext.Provider value={analytics}>
    {children}
  </AnalyticsContext.Provider>
);

export default AnalyticsProvider;
